import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
import Typewriter from 'typewriter-effect/dist/core';
import Rellax from "rellax";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import transitionEffect from "./helpers/transitionEffect";
gsap.registerPlugin(ScrollTrigger);
var te = new transitionEffect();
require("./helpers/Timeline");
require('plyr');
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import { sliderWrapper } from "./helpers/SliderWrapper";
require("./helpers/Map");
// GDPR Custom System
// require ('./helpers/CookieConsent');
// Controllers
require("./helpers/newsletterController");
let mapGlobal;
// Define all actions
let Site = {
    // Plugins
    carousel: carouselWrapper,
    slider: sliderWrapper,
    // Actions
    init: () => {
        Site.global();
    },
    transition: (response) => {
        Site.global();
        Site.scripts(response);
    },
    global: () => {
        Site.carousel();
        Site.slider();
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false,
        });
        Site.filters();
        Site.map();
    },
    map: () => {
    },
    filters: () => {
    },
    scripts: (response) => {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
// barba.init({
//     views: [],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             // te.toggle().eventCallback("onComplete", () => {
//             gsap.to(current.container, {
//                 opacity: 0
//             }).eventCallback("onComplete", () => {
//                 done();
//             });
//             // });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             })
//             // te.toggle()
//             .eventCallback("onComplete", () => {
//                 // te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
$(document).ready(function () {
    Site.init();
    if ($("#filter-form").length) {
        $("#filter-form").on("change", "input", (e) => {
            $("#filter-form").submit();
        });
        $("#filter-form").on("submit", (e) => {
            e.preventDefault();
            let formData = $(e.currentTarget).serializeFormJSON();
            let searchText = $("#search-text").val();
            if (searchText != "") {
                formData.search = searchText;
            }
            formData.modify = true;
            $.get($("#filter-form").attr("action"), formData, (data) => {
                $(".items-system").find(".items").fadeOut(400, () => {
                    $(".items-system").find(".items").html($(data).find(".items-system .items").html());
                    $(".items-system").find(".items").fadeIn(400, () => {
                        $.scrollTo(".items-system", 500);
                    });
                });
            });
        });
        let validated = false;
        $("#search-text").on("keydown", (e) => {
            if (e.keyCode == 13) {
                if (!validated) {
                    $("#filter-form").submit();
                }
                validated = true;
                $("#search-text").trigger("blur");
                setTimeout(() => { validated = false; }, 2000);
            }
        });
        $("#search-text").on("blur", (e) => {
            if (!validated) {
                $("#filter-form").submit();
            }
            validated = true;
            setTimeout(() => { validated = false; }, 2000);
        });
        $("body").on("click", ".page-numbers", (e) => {
            e.preventDefault();
            $.get($(e.currentTarget).attr("href"), (data) => {
                $(".items-system").find(".items").fadeOut(400, () => {
                    $(".items-system").find(".items").html($(data).find(".items-system .items").html());
                    $(".items-system").find(".items").fadeIn(400, () => {
                        $.scrollTo(".items-system", 500);
                    });
                });
            });
        });
    }
    if ($(".items-system").length) {
        let itemsSystem = $(".items-system");
        itemsSystem.on("click", ".activate-filter", (e) => {
            e.preventDefault();
            itemsSystem.toggleClass("filters-opened");
        });
    }
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            // const posY = $(node).offset().top - $("#main-header").height();
            const posY = $(node).offset().top;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    let isNegative = $("#main-header").hasClass("negative");
    $("body").on("click", "#menu-switcher a.switcher", (e) => {
        e.preventDefault();
        $("#main-header").removeClass("negative");
        if (isNegative && $("#nav-main").hasClass("show-menu")) {
            $("#main-header").addClass("negative");
        }
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']", (e) => {
        if (!$(e.currentTarget).hasClass("no-goto")) {
            const elm = $(e.currentTarget).attr("href");
            if ($(elm).length) {
                const posY = $(elm).offset().top;
                $.scrollTo(posY, 400);
            }
        }
    });
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            $('#main-header').addClass('scrolled');
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    //
    const maxElms = $('#values').find(".content").children("ul").children("li").length;
    $('#values').on("click", ".title .actions a", (e) => {
        e.preventDefault();
        $('#values').addClass("no-overflow");
        let direction = $(e.currentTarget).data("action");
        let current = parseInt($('#values').attr("data-step"));
        if (direction == "<" && current > 1) {
            $('#values').attr("data-step", current - 1);
        }
        if (direction == ">" && current < maxElms) {
            $('#values').attr("data-step", current + 1);
        }
        setTimeout(() => {
            $('#values').removeClass("no-overflow");
        }, 600);
    });
    $('#values').on("click", ".content > ul > li > div > h3", (e) => {
        let index = $(e.currentTarget).parent().parent().index();
        $('#values').attr("data-step", index + 1);
        $('#values').addClass("no-overflow");
        setTimeout(() => {
            $('#values').removeClass("no-overflow");
        }, 600);
    });
    if ($("#title").length) {
        var app = document.getElementById('title');
        var typewriter = new Typewriter(app, {
            loop: true
        });
        $.each($(app).attr("data-word").split(","), (k, v) => {
            typewriter.typeString(v).pauseFor(2500).deleteAll();
        });
        typewriter.start();
    }
    if ($('.rellax').length) {
        var rellax = new Rellax('.rellax');
    }
    if ($("#player").length) {
        const player = new Plyr('#player');
    }
});
